type ApiEnv = 'local' | 'development' | 'staging' | 'production';

const apiEnv = (process.env.NEXT_PUBLIC_API_ENV || 'local') as ApiEnv;

export const env = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8080/api',
  staticUrl: process.env.NEXT_PUBLIC_STATIC_URL || 'http://localhost:8080/static',
  apiEnv,

  LOG_LEVEL: process.env.LOG_LEVEL || 'info',
  LOG_FILE: process.env.LOG_FILE || './logs/app.log',

  NODE_ENV: process.env.NODE_ENV || 'development',
  DEBUG: process.env.DEBUG === 'true',
} as const;

export function validateEnv() {
  return true;
}

if (env.NODE_ENV === 'development') {
  console.log(`✅ Environment: ${env.apiEnv} → ${env.apiUrl}`);
}
